import { AssignmentsTable } from "@/app/ProDrivers/Assignments/Components/AssignmentsTable";
import { Outlet, useNavigate, useSearch } from "@tanstack/react-router";
import { WorkOrderAssignmentStatus } from "@/gql/graphql";

const defaultStatuses = [
  WorkOrderAssignmentStatus.Assigned,
  WorkOrderAssignmentStatus.OnRoad,
];

export function AssignmentsTableScreen() {
  const { assignmentStatus, filterSupplierId } = useSearch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/pro-drivers/assignments",
  });

  const navigate = useNavigate();

  return (
    <>
      <AssignmentsTable
        status={assignmentStatus ?? defaultStatuses}
        setStatus={(status) => {
          navigate({
            from: "/$tenant/$orgId/supplier/{-$supplierId}",
            to: "/$tenant/$orgId/supplier/{-$supplierId}/pro-drivers/assignments",
            params: (prev) => prev,
            search: (prev) => ({
              ...prev,
              assignmentStatus: status,
            }),
          });
        }}
        filterSupplierId={filterSupplierId ?? null}
        setFilterSupplierId={(supplierId) => {
          navigate({
            from: "/$tenant/$orgId/supplier/{-$supplierId}",
            to: "/$tenant/$orgId/supplier/{-$supplierId}/pro-drivers/assignments",
            params: (prev) => prev,
            search: (prev) => ({
              ...prev,
              filterSupplierId: supplierId ?? undefined,
            }),
          });
        }}
      />
      <Outlet />
    </>
  );
}
